export enum NotificationType {
  Download = 'DOWNLOAD',
  Message = 'MESSAGE',

}

export enum MessageSeverity {
  WARNING = 'warn',
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info'
}

export interface Notification {
  id: number; // Primary ID
  date: Date
  type: NotificationType;
  severity?: MessageSeverity;
  summary: string;
  detail: string;
  reportDto?: {
    filename: string;
    id: number;
  }
  isRead?: boolean;
}
